import { render, staticRenderFns } from "./BannerView.vue?vue&type=template&id=2cf2db9e&scoped=true"
import script from "./BannerView.vue?vue&type=script&setup=true&lang=ts"
export * from "./BannerView.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./BannerView.vue?vue&type=style&index=0&id=2cf2db9e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf2db9e",
  null
  
)

export default component.exports